(() => {
  'use strict';

  const L = window.lottie;
  if (!L || document.documentElement.dataset.glMotionReady === 'true') return;

  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const calm = reduce || saveData;
  const instances = new Set();
  root.dataset.glMotionReady = 'true';
  root.classList.add('gl-motion-ready');

  const gold = [0.788, 0.659, 0.298, 1];
  const cream = [0.953, 0.918, 0.847, 1];
  const muted = [0.953, 0.918, 0.847, 0.28];

  const animations = {
    orbit: {
      v:'5.12.2', fr:30, ip:0, op:90, w:120, h:120, nm:'GL navigator', ddd:0, assets:[],
      layers:[
        {ddd:0,ind:1,ty:4,nm:'Ring',sr:1,ks:{o:{a:0,k:55},r:{a:0,k:0},p:{a:0,k:[60,60,0]},a:{a:0,k:[0,0,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:'gr',it:[{ty:'el',p:{a:0,k:[0,0]},s:{a:0,k:[82,82]},nm:'Orbit'},{ty:'st',c:{a:0,k:muted},o:{a:0,k:100},w:{a:0,k:3},lc:2,lj:2},{ty:'tm',s:{a:0,k:0},e:{a:0,k:100},o:{a:0,k:0},m:1}],nm:'Ring'}],ip:0,op:90,st:0},
        {ddd:0,ind:2,ty:4,nm:'Core',sr:1,ks:{o:{a:0,k:100},r:{a:1,k:[{t:0,s:[0]},{t:90,s:[-180]}]},p:{a:0,k:[60,60,0]},a:{a:0,k:[0,0,0]},s:{a:1,k:[{t:0,s:[88,88,100]},{t:45,s:[103,103,100]},{t:90,s:[88,88,100]}]}},ao:0,shapes:[{ty:'gr',it:[{ty:'sr',sy:1,pt:{a:0,k:4},p:{a:0,k:[0,0]},r:{a:0,k:45},or:{a:0,k:17},os:{a:0,k:0},ir:{a:0,k:4},is:{a:0,k:0}},{ty:'st',c:{a:0,k:gold},o:{a:0,k:100},w:{a:0,k:3},lc:2,lj:2}],nm:'Core'}],ip:0,op:90,st:0}
      ]
    },
    check: {
      v:'5.12.2', fr:30, ip:0, op:48, w:120, h:120, nm:'GL confirmed', ddd:0, assets:[],
      layers:[
        {ddd:0,ind:1,ty:4,nm:'Circle',sr:1,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[60,60,0]},a:{a:0,k:[0,0,0]},s:{a:1,k:[{t:0,s:[72,72,100]},{t:18,s:[106,106,100]},{t:28,s:[100,100,100]}]}},ao:0,shapes:[{ty:'gr',it:[{ty:'el',p:{a:0,k:[0,0]},s:{a:0,k:[78,78]}},{ty:'st',c:{a:0,k:gold},o:{a:0,k:100},w:{a:0,k:5},lc:2,lj:2},{ty:'tm',s:{a:0,k:0},e:{a:1,k:[{t:0,s:[0]},{t:25,s:[100]}]},o:{a:0,k:-90},m:1}],nm:'Circle'}],ip:0,op:48,st:0},
        {ddd:0,ind:2,ty:4,nm:'Tick',sr:1,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[60,60,0]},a:{a:0,k:[0,0,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:'gr',it:[{ty:'sh',ks:{a:0,k:{i:[[0,0],[0,0],[0,0]],o:[[0,0],[0,0],[0,0]],v:[[-21,1],[-6,17],[25,-19]],c:false}}},{ty:'st',c:{a:0,k:cream},o:{a:0,k:100},w:{a:0,k:7},lc:2,lj:2},{ty:'tm',s:{a:0,k:0},e:{a:1,k:[{t:16,s:[0]},{t:38,s:[100]}]},o:{a:0,k:0},m:1}],nm:'Tick'}],ip:0,op:48,st:0}
      ]
    },
    scan: {
      v:'5.12.2',fr:30,ip:0,op:72,w:120,h:120,nm:'GL scan',ddd:0,assets:[],
      layers:[
        {ddd:0,ind:1,ty:4,nm:'Frame',sr:1,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:0,k:[60,60,0]},a:{a:0,k:[0,0,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:'gr',it:[{ty:'rc',p:{a:0,k:[0,0]},s:{a:0,k:[78,62]},r:{a:0,k:8}},{ty:'st',c:{a:0,k:muted},o:{a:0,k:100},w:{a:0,k:3},lc:2,lj:2}],nm:'Frame'}],ip:0,op:72,st:0},
        {ddd:0,ind:2,ty:4,nm:'Beam',sr:1,ks:{o:{a:0,k:100},r:{a:0,k:0},p:{a:1,k:[{t:0,s:[60,36,0]},{t:36,s:[60,84,0]},{t:72,s:[60,36,0]}]},a:{a:0,k:[0,0,0]},s:{a:0,k:[100,100,100]}},ao:0,shapes:[{ty:'gr',it:[{ty:'sh',ks:{a:0,k:{i:[[0,0],[0,0]],o:[[0,0],[0,0]],v:[[-35,0],[35,0]],c:false}}},{ty:'st',c:{a:0,k:gold},o:{a:0,k:100},w:{a:0,k:4},lc:2,lj:2}],nm:'Beam'}],ip:0,op:72,st:0}
      ]
    }
  };

  function mount(el, name, options = {}) {
    if (!el || el.dataset.glLottieMounted) return null;
    el.dataset.glLottieMounted = name;
    el.classList.add('gl-motion-slot');
    el.setAttribute('aria-hidden', 'true');
    const instance = L.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: calm ? false : options.loop !== false,
      autoplay: !calm && options.autoplay !== false,
      animationData: animations[name] || animations.orbit,
      rendererSettings: { progressiveLoad: true, preserveAspectRatio: 'xMidYMid meet' }
    });
    instances.add(instance);
    instance.addEventListener('destroy', () => instances.delete(instance));
    if (calm) instance.goToAndStop(options.restFrame || 24, true);
    return instance;
  }

  function slot(className = '') {
    const el = document.createElement('span');
    el.className = className;
    return el;
  }

  function addPageSignal() {
    if (document.querySelector('.gl-page-signal')) return;
    const signal = document.createElement('div');
    signal.className = 'gl-page-signal';
    signal.setAttribute('aria-hidden', 'true');
    document.body.prepend(signal);
  }

  function enhanceHeader() {
    const icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.gl-nav-beacon')) return;
    const beacon = slot('gl-nav-beacon');
    icons.prepend(beacon);
    const animation = mount(beacon, 'orbit', { loop: false, autoplay: false });
    if (!calm && animation) {
      const play = () => animation.goToAndPlay(0, true);
      const rest = () => animation.goToAndStop(0, true);
      icons.addEventListener('mouseenter', play, { passive: true });
      icons.addEventListener('mouseleave', rest, { passive: true });
      icons.addEventListener('focusin', play, { passive: true });
      icons.addEventListener('focusout', rest, { passive: true });
    }
  }

  function enhanceButtons(scope = document) {
    scope.querySelectorAll('.button, button, [role="button"]').forEach((button) => {
      if (button.closest('.shopify-payment-button') || button.classList.contains('gl-motion-focus')) return;
      button.classList.add('gl-motion-focus');
    });
    scope.querySelectorAll('product-form form [name="add"], .quick-add__submit').forEach((button) => {
      if (button.dataset.glMotionButton) return;
      button.dataset.glMotionButton = 'true';
      button.classList.add('gl-button-motion');
      const label = button.querySelector('span:not(.loading__spinner)');
      if (label) label.classList.add('gl-button-label');
      const icon = slot('gl-button-lottie');
      button.prepend(icon);
      button.addEventListener('click', () => {
        button.classList.remove('gl-motion-success');
        button.classList.add('gl-motion-pending');
        const animation = mount(icon, 'orbit', { loop: true });
        if (!calm && animation) animation.play();
        window.setTimeout(() => button.classList.remove('gl-motion-pending'), 4500);
      }, { passive: true });
    });
  }

  function addProductConfidence() {
    if (!document.body.classList.contains('template-product') && !document.querySelector('product-info')) return;
    const form = document.querySelector('product-form');
    if (!form || document.querySelector('.gl-product-confidence')) return;
    const rail = document.createElement('div');
    rail.className = 'gl-product-confidence';
    rail.setAttribute('aria-label', 'Purchase confidence');
    const items = [
      ['Product clarity', 'Specs and options up front'],
      ['Secure checkout', 'Protected Shopify payment'],
      ['Order tracking', 'Updates after purchase']
    ];
    items.forEach(([title, detail], index) => {
      const item = document.createElement('div');
      item.className = 'gl-confidence-item';
      const icon = slot();
      const copy = document.createElement('div');
      copy.className = 'gl-confidence-copy';
      const strong = document.createElement('strong');
      const span = document.createElement('span');
      strong.textContent = title;
      span.textContent = detail;
      copy.append(strong, span);
      item.append(icon, copy);
      rail.append(item);
      mount(icon, index === 1 ? 'check' : index === 2 ? 'scan' : 'orbit', { loop: false });
    });
    form.before(rail);
  }

  function enhanceSearch(scope = document) {
    scope.querySelectorAll('.predictive-search__loading-state, .predictive-search-status').forEach((state) => {
      if (state.querySelector('.gl-search-motion')) return;
      const icon = slot('gl-search-motion');
      state.prepend(icon);
      mount(icon, 'scan', { loop: true });
    });
  }

  function enhanceEmptyStates(scope = document) {
    const selectors = [
      '.cart-drawer__empty-content',
      '.cart__empty-text',
      '.collection--empty .title-wrapper',
      '.template-search__results-empty'
    ];
    scope.querySelectorAll(selectors.join(',')).forEach((empty) => {
      if (empty.querySelector('.gl-empty-motion')) return;
      const icon = slot('gl-empty-motion');
      empty.prepend(icon);
      mount(icon, empty.closest('[class*="search"]') ? 'scan' : 'orbit', { loop: true });
    });
  }

  function showCartSuccess() {
    const drawer = document.querySelector('#CartDrawer .drawer__inner, cart-notification .cart-notification__links');
    if (!drawer) return;
    drawer.querySelector('.gl-cart-success')?.remove();
    const notice = document.createElement('div');
    notice.className = 'gl-cart-success';
    notice.setAttribute('role', 'status');
    const icon = slot();
    const copy = document.createElement('div');
    const strong = document.createElement('strong');
    const span = document.createElement('span');
    strong.textContent = 'Added to your build';
    span.textContent = 'Ready when you are.';
    copy.append(strong, span);
    notice.append(icon, copy);
    drawer.prepend(notice);
    const animation = mount(icon, 'check', { loop: false });
    if (!calm && animation) animation.play();
    window.setTimeout(() => notice.remove(), 4200);
  }

  // Reveal-on-scroll for top-level sections. FIXED 2026-09-12: this used to
  // hide every section (opacity 0 via the paired .gl-reveal/.gl-in-view CSS
  // in gl-motion-core.css) until an IntersectionObserver callback added
  // '.gl-in-view'. Live incident: the homepage rendered completely blank
  // (confirmed via screenshot -- header only, full page content present in
  // the DOM but invisible) because that first callback never fired, even
  // for a section already in the viewport at load. This is the same bug
  // class already fixed once before for gl-picks-grid.liquid (see
  // memory/learnings.md, "Picks Grid invisible reveal bug", 2026-08-22) --
  // CLAUDE.md SS11 is explicit that no motion may be required to understand
  // content. A forced-visible fallback timer guarantees that even if the
  // observer never fires, every section is shown within ~1s -- the scroll
  // animation still plays normally for everyone else.
  function revealSections(scope = document) {
    if (calm || !('IntersectionObserver' in window)) return;
    const targets = scope.querySelectorAll('main .shopify-section:not(.gl-reveal), main > section:not(.gl-reveal)');
    if (!targets.length) return;

    // FAIL-OPEN GATE. The paired CSS only hides a .gl-reveal element while
    // <html> carries .gl-motion-active, and this is the ONLY line that ever
    // sets it -- so the hidden state cannot exist unless this exact code
    // path ran and is about to start observing. If the script never loads,
    // throws earlier, or is blocked, no class is set and nothing is ever
    // hidden. That is the structural fix for the blank-page class of bug;
    // the watchdog below is then only a second line of defence rather than
    // the thing standing between a visitor and a readable page.
    root.classList.add('gl-motion-active');

    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('gl-in-view');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });

    targets.forEach((target) => {
      target.classList.add('gl-reveal');
      io.observe(target);
      // Second line of defence: some engines (and several automation and
      // background-tab contexts, reproduced live 2026-09-12) never deliver
      // the initial IntersectionObserver callback at all, even for an
      // element already inside the viewport.
      window.setTimeout(() => {
        if (target.classList.contains('gl-in-view')) return;
        target.classList.add('gl-in-view');
        io.unobserve(target);
      }, 1200);
    });
  }

  let cartWasBusy = false;
  const observer = new MutationObserver((mutations) => {
    let needsEnhancement = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) needsEnhancement = true;
    });
    const busy = Boolean(document.querySelector('product-form form [name="add"][aria-disabled="true"], product-form form [name="add"].loading'));
    const cartOpen = Boolean(document.querySelector('cart-drawer.active, cart-notification.active, cart-notification[active]'));
    if (cartWasBusy && !busy && cartOpen) showCartSuccess();
    cartWasBusy = busy;
    if (needsEnhancement) {
      enhanceButtons();
      enhanceSearch();
      enhanceEmptyStates();
    }
  });

  function boot() {
    addPageSignal();
    enhanceButtons();
    addProductConfidence();
    enhanceSearch();
    enhanceEmptyStates();
    revealSections();
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-disabled'] });

    document.addEventListener('click', (event) => {
      const anchor = event.target.closest('a[href]');
      if (!anchor || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(anchor.href, location.href);
      if (url.origin === location.origin && url.href !== location.href && !anchor.hasAttribute('download') && anchor.target !== '_blank') {
        root.classList.add('gl-is-navigating');
      }
    }, true);

    window.addEventListener('pageshow', () => root.classList.remove('gl-is-navigating'));
    document.addEventListener('visibilitychange', () => {
      const paused = document.hidden;
      root.classList.toggle('gl-motion-paused', paused);
      instances.forEach((instance) => paused ? instance.pause() : (!calm && instance.play()));
    });
    document.addEventListener('shopify:section:load', (event) => {
      enhanceButtons(event.target);
      enhanceSearch(event.target);
      enhanceEmptyStates(event.target);
      revealSections(event.target);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
